<template>
  <div
    class="view-pipeline-page"
    :class="{ 'view-pipeline-page--table': viewMode === 'table' }"
  >
    <template v-if="viewMode === 'board'">
      <v-card flat class="view-pipeline-card d-flex flex-column">
        <v-card-text class="view-pipeline-card-text">
          <div class="view-pipeline-card-text__header d-flex align-center mb-4">
            <div class="text-h5 flex-grow-1">
              {{ pipelineName || "-" }}
            </div>
            <v-btn-toggle
              v-model="viewMode"
              mandatory
              dense
              class="view-pipeline-view-toggle"
            >
              <v-btn value="board" small>
                <v-icon small left>mdi-view-column</v-icon>
                {{ $t("PIPELINES.VIEW_BOARD") }}
              </v-btn>
              <v-btn value="table" small>
                <v-icon small left>mdi-table</v-icon>
                {{ $t("PIPELINES.VIEW_TABLE") }}
              </v-btn>
            </v-btn-toggle>
          </div>

          <PipelineBoard
            :pipeline-id="pipelineId"
            @pipeline-loaded="onPipelineLoaded"
          />
        </v-card-text>
      </v-card>
    </template>

    <template v-else>
      <div class="view-pipeline-card-text__header d-flex align-center mb-4">
        <div class="text-h5 flex-grow-1">
          {{ pipelineName || "-" }}
        </div>
        <v-btn-toggle
          v-model="viewMode"
          mandatory
          dense
          class="view-pipeline-view-toggle"
        >
          <v-btn value="board" small>
            <v-icon small left>mdi-view-column</v-icon>
            {{ $t("PIPELINES.VIEW_BOARD") }}
          </v-btn>
          <v-btn value="table" small>
            <v-icon small left>mdi-table</v-icon>
            {{ $t("PIPELINES.VIEW_TABLE") }}
          </v-btn>
        </v-btn-toggle>
      </div>

      <DealsTable
        :pipeline-id="pipelineId"
        :title="pipelineName"
        @pipeline-loaded="onPipelineLoaded"
      />
    </template>
  </div>
</template>

<script>
import PipelineBoard from "@/views/pages/pipelines/partials/PipelineBoard";
import DealsTable from "@/views/partials/deals/DealsTable";

export default {
  name: "ViewPipeline",
  components: {
    PipelineBoard,
    DealsTable,
  },
  data() {
    return {
      pipelineName: "",
      viewMode: "board",
    };
  },
  computed: {
    pipelineId() {
      return this.$route.params.id;
    },
  },
  mounted() {
    if (!this.hasPermissions("pipelines-view-all") || !this.hasPermissions("deals-view-all")) {
      this.$router.push({ name: "dashboard" });
      return;
    }

    this.viewMode = "board";
  },
  watch: {
    pipelineId() {
      this.pipelineName = "";
      this.viewMode = "board";
    },
  },
  methods: {
    onPipelineLoaded({ name }) {
      this.pipelineName = name || "";
    },
  },
};
</script>

<style scoped>
.view-pipeline-page {
  margin: -25px;
  width: calc(100% + 50px);
  max-width: none;
  height: calc(100vh - 65px);
  min-height: calc(100vh - 65px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-top: 2px solid rgba(0, 0, 0, 0.12);
  background-color: #fff;
}

.view-pipeline-page--table {
  margin: 0;
  width: 100%;
  max-width: 100%;
  height: auto;
  min-height: 0;
  overflow: visible;
  border-top: none;
  background-color: transparent;
}

.view-pipeline-card {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #fff !important;
}

.view-pipeline-card-text {
  flex: 1 1 auto;
  min-height: 0;
  display: flex !important;
  flex-direction: column;
  overflow: hidden;
  background-color: #fff !important;
}

.view-pipeline-card-text__header {
  flex-shrink: 0;
}

.view-pipeline-view-toggle {
  flex-shrink: 0;
}

@media (max-width: 1023px) {
  .view-pipeline-page:not(.view-pipeline-page--table) {
    margin: -15px;
    width: calc(100% + 30px);
    height: calc(100vh - 56px);
    min-height: calc(100vh - 56px);
  }
}
</style>
